<template>
  <div class="addAddress absolute">
    <div class="container">
      <div class="list">
        <div class="item">
          <div class="name">姓名</div>
          <input
            type="text"
            placeholder="請輸入姓名"
            v-model="userAddress.real_name"
            required
          />
        </div>
        <div class="item">
          <div class="name">電話</div>
          <input
            type="text"
            placeholder="請輸入聯繫電話"
            v-model="userAddress.phone"
            required
          />
          <button
            :class="disabled ? 'send-code disabled-send' : 'send-code'"
            :disabled="disabled"
            @click="sendVerify"
          >
            {{ text }}
          </button>
        </div>
        <div class="item">
          <div class="name">验证码</div>
          <input
            type="text"
            placeholder="请输入验证码"
            v-model="userAddress.code"
            required
          />
        </div>
        <div class="item">
          <div class="name">地址</div>
          <div class="picker select-value form-control">
            <div class="address">
              <div slot="right" @click.stop="show2 = true">
                {{ model2 || "請選擇收貨地址" }}
              </div>
              <CitySelect
                ref="cityselect"
                v-model="show2"
                :callback="result2"
                :items="district"
                :ready="ready"
                provance=""
                city=""
                area=""
              ></CitySelect>
            </div>
            <div class="dingwei"></div>
          </div>
        </div>
        <div class="item">
          <input
            type="text"
            placeholder="請填寫具體地址"
            v-model="userAddress.detail"
            required
            class="detailed-address"
          />
        </div>
      </div>
      <div class="default">
        <div class="select-btn">
          <div class="checkbox-wrapper">
            <div class="set-default">設置為默認地址</div>
            <el-switch
              v-model="userAddress.is_default"
              @click="ChangeIsDefault"
            ></el-switch>
          </div>
        </div>
      </div>
      <div></div>
      <div class="keepBnt" @click="submit">立即保存</div>
      <!-- v-if="isWechat && !id" -->
      <div class="wechatAddress" @click="getAddress">
        導入微信地址
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
import { CitySelect } from "vue-ydui/dist/lib.rem/cityselect";
import { getAddress, postAddress, registerVerify } from "@api/user";
import { getCity } from "@api/public";
import attrs, { required, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { openAddress } from "@libs/wechat";
import { isWeixin } from "@utils";
import SendVerifyCode from "@mixins/SendVerifyCode";

export default {
  components: {
    CitySelect
  },
  mixins: [SendVerifyCode],
  data() {
    return {
      show2: false,
      model2: "",
      district: [],
      id: 0,
      userAddress: { is_default: 0 },
      address: {},
      isWechat: isWeixin(),
      ready: false
    };
  },
  mounted: function() {
    let id = this.$route.params.id;
    this.id = id;
    document.title = !id ? "添加地址" : "修改地址";
    this.getUserAddress();
    this.getCityList();
  },
  methods: {
    getCityList: function() {
      let that = this;
      getCity().then(res => {
        that.district = res.data;
        that.ready = true;
      });
    },
    getUserAddress: function() {
      if (!this.id) return false;
      let that = this;
      getAddress(that.id).then(res => {
        that.userAddress = res.data;
        that.model2 =
          res.data.province + " " + res.data.city + " " + res.data.district;
        that.address.province = res.data.province;
        that.address.city = res.data.city;
        that.address.city_id = res.data.city_id;
      });
    },
    getAddress() {
      openAddress().then(userInfo => {
        this.$dialog.loading.open();
        console.log("openAddress成功");
        // console.log("getAd");
        // console.log(userInfo);
        // this.userAddress.real_name = userInfo.userName;
        // this.userAddress.phone = userInfo.telNumber;
        // this.model2 =
        //   userInfo.provinceName +
        //   " " +
        //   userInfo.cityName +
        //   " " +
        //   userInfo.countryName;
        // this.address.province = userInfo.provinceName;
        // this.address.city = userInfo.cityName;
        // this.address.district = userInfo.countryName;
        // this.userAddress.detail = userInfo.detail;
        postAddress({
          id: this.id,
          real_name: userInfo.userName,
          phone: userInfo.telNumber,
          address: {
            province: userInfo.provinceName,
            city: userInfo.cityName,
            district: userInfo.countryName
          },
          detail: userInfo.detailInfo,
          is_default: 1,
          post_code: userInfo.postalCode,
          type: 1
        })
          .then(() => {
            this.$dialog.loading.close();
            this.$dialog.toast({ mes: "添加成功" });
            this.$router.go(-1);
          })
          .catch(err => {
            this.$dialog.loading.close();
            this.$dialog.error(err.msg || "添加失敗");
          });
      });
    },
    async submit() {
      console.log("come in");
      let name = this.userAddress.real_name,
        phone = this.userAddress.phone,
        model2 = this.model2,
        detail = this.userAddress.detail,
        code = this.userAddress.code,
        isDefault = this.userAddress.is_default;
      try {
        await this.$validator({
          name: [
            required(required.message("姓名")),
            attrs.range([2, 16], attrs.range.message("姓名"))
          ],
          phone: [
            required(required.message("聯繫電話")),
            chs_phone(chs_phone.message())
          ],
          model2: [required("請選擇地址")],
          detail: [required(required.message("具體地址"))],
          code: [required(required.message("验证码"))]
        }).validate({ name, phone, model2, detail, code });
      } catch (e) {
        console.log("yes?");
        console.log(e);
        return validatorDefaultCatch(e);
      }
      try {
        let that = this,
          data = {
            id: that.id,
            real_name: name,
            phone: phone,
            address: this.address,
            detail: detail,
            is_default: isDefault,
            code: code
          };
        postAddress(data).then(
          function() {
            console.log("zheli?");
            if (that.id) that.$dialog.toast({ mes: "修改成功" });
            else that.$dialog.toast({ mes: "添加成功" });
            that.$router.go(-1);
          },
          err => {
            console.log("how?");
            console.log(err);
            this.$dialog.toast({
              mes: err.msg
            });
          }
        );
      } catch (e) {
        console.log("?");
        this.$dialog.toast({
          mes: e.msg
        });
      }
    },
    ChangeIsDefault: function() {
      this.userAddress.is_default = !this.userAddress.is_default;
    },
    result2(ret) {
      this.model2 = ret.itemName1 + " " + ret.itemName2 + " " + ret.itemName3;
      this.address.province = ret.itemName1;
      this.address.city = ret.itemName2;
      this.address.city_id = ret.itemValue2;
      this.address.district = ret.itemName3;
    },
    sendVerify() {
      let data = {
        phone: this.userAddress.phone,
        type: "verify",
        key: "",
        code: ""
      };
      registerVerify(data)
        .then(res => {
          console.log(res);
          this.$dialog.toast({
            mes: res.msg
          });
          this.sendCode();
        })
        .catch(err => {
          this.$dialog.toast({
            mes: err.msg
          });
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.addAddress {
  height: 100%;
  background-color: rgb(244, 250, 254);
  padding: 0.3rem;
  .container {
    background-color: #fff;
    padding: 0.4rem;
    border-radius: 0.3rem;
    .list {
      .item {
        display: flex;
        align-items: center;
        margin-bottom: 0.2rem;
        .name {
          margin-right: 0.25rem;
          font-size: 0.33rem;
        }
        input {
          width: 55%;
          padding: 0.2rem 0.1rem;
          border-bottom: 1px solid lightgray;
        }
        ::placeholder {
          color: #b9b9bc;
        }
        .send-code {
          padding: 0.1rem 0.2rem;
          border-radius: 0.3rem;
          color: #fff;
          background-color: rgb(73, 174, 241);
          text-align: center;
        }
        .disabled-send {
          opacity: 0.5;
        }
        .detailed-address {
          width: 95%;
        }
      }
      .picker {
        display: flex;
        align-items: center;
        width: 80%;
        padding: 0.2rem 0.1rem;
        border-bottom: 1px solid lightgray;
        .address {
          flex-grow: 1;
        }
        .dingwei {
          background-image: url("../../../../assets/moblie/images/dingwei1@3x.png");
          background-size: 100% 100%;
          width: 0.35rem;
          height: 0.37rem;
        }
      }
    }
    .default {
      .select-btn {
        .checkbox-wrapper {
          width: 95%;
          display: flex;
          align-items: center;
          .set-default {
            flex-grow: 1;
          }
        }
      }
    }
    .keepBnt {
      width: 95%;
      background-color: rgb(73, 174, 241);
      text-align: center;
      color: #fff;
      margin: 0.3rem 0;
      padding: 0.2rem;
      box-sizing: border-box;
      border-radius: 0.5rem;
    }
    .wechatAddress {
      width: 95%;
      background-color: #fff;
      text-align: center;
      color: rgb(73, 174, 241);
      border: 1px solid rgb(73, 174, 241);
      margin: 0.3rem 0;
      padding: 0.2rem;
      box-sizing: border-box;
      border-radius: 0.5rem;
    }
  }
}
</style>
